import { useTranslation } from 'react-i18next';
import { useDriverApi } from '@hero/api-hooks';
import { UserIcon } from '@hero/web-icons';
import type { Id } from '@hero/schema';
import { EntityLink } from './EntityLink';

export interface DriverCardWidgetProps {
  driverId: Id;
  displaySnapshot?: { name?: string; phone?: string };
}

export const DriverCardWidget = ({ driverId, displaySnapshot }: DriverCardWidgetProps) => {
  const { t } = useTranslation('m-agent');
  const { data: driver } = useDriverApi(driverId);
  const name =
    driver?.name ??
    displaySnapshot?.name ??
    t('widgets.driver_card.fallback', 'Driver');
  const phone = driver?.phone ?? displaySnapshot?.phone;

  return (
    <EntityLink
      kind='driver'
      entityId={String(driverId)}
      label={name}
      subtitle={phone}
      icon={<UserIcon className='size-4' />}
    />
  );
};
